import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User adds a starting point in the custom route builder
 */
const logCustomRouteStartingPointAdded = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('custom route starting point added', {}, callback);
};

export default logCustomRouteStartingPointAdded;
